import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

export function setNavigator(navigate: NavigateFunction) {
  navigateRef = navigate;
}

export function navigate(to: To, options?: NavigateOptions) {
  if (navigateRef) {
    navigateRef(to, options);
  } else if (typeof window !== 'undefined') {
    if (typeof to === 'string') {
      window.location.href = to;
    } else {
      // Best-effort fallback
      window.location.href = typeof to.pathname === 'string' ? to.pathname : '/';
    }
  }
}

export function redirectToSystemUnavailable() {
  const path = '/system-unavailable';
  if (typeof window !== 'undefined' && window.location.pathname === path) return;
  try {
    navigate(path, { replace: true });
  } catch {
    if (typeof window !== 'undefined') window.location.href = path;
  }
}
